import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OrderProvider } from '../providers/order.provider';
import { SelectedProductInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface RemoveOrderUseCaseParams {
    product: SelectedProductInterface;
}

@Injectable()
export class RemoveOrderUseCase implements UseCaseWithParam<RemoveOrderUseCaseParams, Observable<Transaction<boolean>>> {
    constructor(private orderProvider: OrderProvider) {}

    bind(params: RemoveOrderUseCaseParams): Observable<Transaction<boolean>> {
        return this.orderProvider.remove(params.product);
    }
}
